<template>
  <div class="home shadow px-4 py-4 rounded">
    <div>
      <div v-if="!wishlist.length > 0">
        <img
          src="~@/assets/icons/empty-cart.svg"
          class="mx-auto"
          style="width: 50%; height: 50%;"
        />
        <p class="text-center m-5 bold">
          Currently No Items in Your wishlist
        </p>
        <div class="flex justify-center ">
          <lms-button
            class="btn-color  "
            textColor="#fff"
            @click="$router.push({ name: 'learner-courses' })"
            >View Available Courses</lms-button
          >
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="w-full">
          <div>
            <wishlist-item
              :course="item.course"
              v-for="(item,index) in wishlist"
              :wishlist_index="index"
              :key="index"
              @addCart="addToCart(item.course)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "wishlist-page",
  components: {
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    wishlistItem: () => import("@/components/learner/wishlistItem"),
  },
  data() {
    return {
      course: null,
      ref: null,
    };
  },
  computed: {
    ...mapGetters({
      wishlist: "getLearnerWish",
      user: "getUser",
    }),
    items() {
      return [];
      return Object.values(this.wishlist);
    },
  },
  methods: {
    ...mapActions(["fetchWishlist","learnerAddToCart","learnerAddToWishlist"]),
    async addToCart(item) {
      this.learnerAddToCart({
        ...item,
      });
      await this.$swal({
        title: "Item Successfully Added to Cart",
        cancelButtonText: "Continue Shopping",
        confirmButtonText: "Go To Cart",
        showCancelButton: true,
      }).then((res) => {
        if (res.isConfirmed) {
          this.$router.push({ name: "learner-cart" });
        }
      });
    },
     initializeLocalWishLists(){
      let local_wishlists = JSON.parse( localStorage.getItem('lms_wishlist'))
      if (  typeof local_wishlists == "undefined"  || local_wishlists === null || !local_wishlists.length > 0){
        return;
      }
       for (let i = 0; i < local_wishlists.length; i++){
         this.learnerAddToWishlist({
           id : local_wishlists[i]
         })
       }

    }
  },
  async mounted() {
    await this.initializeLocalWishLists()
    await this.fetchWishlist();
  },
};
</script>
